function remove<T extends { id: string }>(items: T[], id: T['id']) {
  return items.filter(item => item.id !== id);
}

export { remove };
